import Button from "../components/Button";
import Icon from "../components/Icon";
import ImageWrapper from "../components/ImageWrapper";
import about1 from "../assets/img/about1.jpg";
import about2 from "../assets/img/about2.jpg";
import Marquee from "react-fast-marquee";
import { marqueeData } from "../utils/marquee";
import ContactForm from "../sections/ContactForm";
import { useLayoutEffect, useState } from "react";
import gsap from "gsap";
import DoctorTimeline from "../components/DoctorTimeline";
import { lyuben, daliya } from "../utils/doctorInfo";

export default function About() {
  let mm = gsap.matchMedia();
  const [modalData, setModalData] = useState(null);

  useLayoutEffect(() => {
    gsap.from(".hero h1", {
      yPercent: 50,
      opacity: 0,
      duration: 1,
    });

    mm.add("(min-width: 800px)", () => {
      gsap.from(".about .gsap_reveal", {
        yPercent: 25,
        opacity: 0,
        duration: 1,
        stagger: 0.25,
        scrollTrigger: {
          trigger: ".about .gsap_reveal",
        },
      });
    });
  }, []);

  return (
    <>
      <div className="hero bg-hero-home-dark w-full h-[80vh] bg-cover bg-center flex items-center justify-center">
        <h1 className="text-4xl lg:text-5xl text-white font-extrabold">
          За Нас
        </h1>
      </div>
      {lyuben && daliya && (
        <>
          <DoctorTimeline
            doctorName={lyuben.doctorName}
            doctorImage={lyuben.doctorImage}
            doctorDescription={lyuben.doctorDescription}
            timelineEvents={lyuben.timelineEvents}
          />
          <DoctorTimeline
            direction="reverse"
            doctorName={daliya.doctorName}
            doctorImage={daliya.doctorImage}
            doctorDescription={daliya.doctorDescription}
            timelineEvents={daliya.timelineEvents}
          />
        </>
      )}
      {/* <div className="about page__width mt-20 flex flex-col-reverse justify-between lg:flex-row items-center gap-8">
        <div className="w-full lg:w-1/2">
          <ImageWrapper
            src={about1}
            className="w-full gsap_reveal rounded-lg"
          />
        </div>
        <div className="gsap_reveal w-full lg:w-2/5 flex gap-2 flex-col items-start">
          <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-3xl font-extrabold text-heading">
            20+ години сертифицирана дентална практика
          </h2>
          <p className="text-base text-body font-normal">
            С над 20-годишен опит TomovDental си е изградила репутация на
            отличен специалист. Нашият екип е в крак с най-новите дентални
            технологии и техники, за да гарантираме, че получавате възможно
            най-доброто лечени.
          </p>
          <Button type="cta-border" href="/contact">
            Запазете час още сега!
          </Button>
        </div>
      </div> */}
      <div className="my-20 flex flex-col items-center">
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-center text-2xl lg:text-3xl font-extrabold text-heading w-5/6 mx-auto mb-8">
          А ето и какво постигаме с пациентите си:
        </h2>
        <div className="w-full flex flex-wrap items-center justify-center gap-4">
          {marqueeData[0].map((img) => {
            return (
              <ImageWrapper
                src={img.src}
                alt={img.alt}
                className="w-3/12 lg:w-[15%] h-auto rounded-lg hover:scale-90 duration-300 transition-all cursor-pointer"
                onClick={() => setModalData(img)}
              />
            );
          })}
        </div>
        <div className="w-full flex flex-wrap mt-4 items-center justify-center gap-4">
          {marqueeData[1].map((img) => {
            return (
              <ImageWrapper
                src={img.src}
                alt={img.alt}
                className="w-3/12 lg:w-[15%] h-auto rounded-lg hover:scale-90 duration-300 transition-all cursor-pointer"
                onClick={() => setModalData(img)}
              />
            );
          })}
        </div>
        {/* <Marquee
                    className="w-full"
                    autoFill>
                    {marqueeData[0].map((img) => {
                        return (
                            <>
                                <ImageWrapper
                                    src={img.src}
                                    alt={img.alt}
                                    className="w-40 h-40 lg:w-64 lg:h-64 mx-3 lg:mx-6 rounded-lg hover:scale-90 duration-300 transition-all cursor-pointer"
                                    onClick={() => setModalData(img)}
                                />
                            </>
                        );
                    })}
                </Marquee>
                <Marquee
                    className="w-full mt-12"
                    direction="right"
                    autoFill>
                    {marqueeData[1].map((img) => {
                        return (
                            <>
                                <ImageWrapper
                                    src={img.src}
                                    alt={img.alt}
                                    className="w-40 h-40 lg:w-64 lg:h-64 mx-3 lg:mx-6 rounded-lg hover:scale-90 duration-300 transition-all cursor-pointer"
                                    onClick={() => setModalData(img)}
                                />
                            </>
                        );
                    })}
                </Marquee> */}
        {modalData ? (
          <div className="w-screen h-screen flex items-center justify-center fixed top-0 bottom-0 left-0 right-0 z-[99]">
            <div
              className="w-screen h-screen fixed top-0 bottom-0 left-0 right-0 bg-black bg-opacity-60"
              onClick={() => setModalData(null)}
            ></div>
            <div className="relative flex flex-col lg:flex-row items-center gap-8 w-3/4 bg-white rounded-lg p-8 z-[999]">
              <ImageWrapper
                src={modalData.src}
                alt="Modal Image"
                className="w-full lg:w-1/3 rounded-lg"
              />
              <div className="flex w-full lg:w-2/3 flex-col gap-4 items-start">
                <h3 className="text-2xl lg:text-3xl font-bold text-heading">
                  {modalData.title}
                </h3>
                <p className="text-base lg:text-lg text-heading">
                  {modalData.description}
                </p>
              </div>
              <button
                className="lg:absolute top-4 right-4 flex items-center justify-center rounded-full border-2 font-bold border-brand text-brand bg-none px-4 py-2 hover:text-white hover:bg-brand transition-all duration-200"
                onClick={() => setModalData(null)}
              >
                Затвори
              </button>
            </div>
          </div>
        ) : null}
      </div>
      {/* <div className="w-full flex items-center">
                <Button
                    type="cta-border"
                    className="mx-auto"
                    href="#">
                    Виж всички резултати
                </Button>
            </div> */}
      <div className="page__width flex flex-col items-center justify-center my-20">
        <div className="flex items-center gap-1">
          <div className="bg-brand w-16 rounded-full h-[6px]"></div>
          <div className="bg-brand w-8 rounded-full h-[6px]"></div>
          <div className="bg-brand w-2 rounded-full h-[6px]"></div>
        </div>
        <h2 className="text-3xl font-extrabold text-heading my-8">
          Свържете се с нас
        </h2>
        <div className="flex flex-col lg:flex-row w-full items-center justify-between gap-4">
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="email" className="w-10 h-10" />
            <a
              href="mailto:tomov.dentalclinic@gmail.com"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              tomov.dentalclinic
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="phone" className="w-10 h-10" />
            <a
              href="tel:088 528 5757"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              088 528 5757
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 w-full lg:w-[30%] p-8 rounded-lg bg-[#ECF6FD]">
            <Icon name="location" className="w-10 h-10" />
            <a
              href="https://maps.app.goo.gl/GWjbmeVQZosEFJNv9"
              target="_blank"
              className="text-heading hover:underline font-bold text-lg"
            >
              ul.Opalchenska 94
            </a>
          </div>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2931.8174914281817!2d23.313118100000004!3d42.707585099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa85ed09dbf16d%3A0xcfff98bb12f6872!2sTomov%20Dental%20Clinic!5e0!3m2!1sen!2sbg!4v1718888234195!5m2!1sen!2sbg"
          className="w-full mt-8 rounded-xl"
          height="600"
          style={{ border: 0 }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="w-[90%] lg:w-1/2 mx-auto">
        <ContactForm />
      </div>
      <div className="page__width cta my-20 bg-cover bg-right lg:bg-center flex flex-col lg:items-start justify-center bg-cta-dark lg:bg-cta py-16 px-8 items-center text-center lg:text-start lg:px-16 lg:py-24 rounded-xl">
        <h2 className="text-3xl lg:text-4xl w-full lg:w-1/2 mb-6 text-white font-extrabold">
          Блестящата усмивка е на една ръка разстояние
        </h2>
        <Button href="/contact">Свържи се с нас</Button>
      </div>
    </>
  );
}
